import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=25427d26&scoped=true&lang=pug&"
var script = {}
import style0 from "./Settings.vue?vue&type=style&index=0&id=25427d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25427d26",
  null
  
)

export default component.exports